import styled from "styled-components";
import colors from "../../../assets/styles/colors";

export const DownloadDocumentsButton = styled.button`
  box-shadow: 0px 5px 10px ${colors.shadow};
  border-radius: 48px;
  cursor: pointer;
  border: 1px solid ${colors.bgTertiaryLight};
  background-color: ${colors.bgTertiary};
  height: 52px;
  width: 100%;
  color: ${colors.bgPrimary};
  font-weight: bold;
  font-size: 14px;
  line-height: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: .2s;

  &:hover {
    background: ${colors.bgTertiaryHover};
    border: 1px solid ${colors.bgTertiaryHover};
    box-shadow: 0px 5px 15px ${colors.shadowHover};
  }

  svg {
    margin-left: 10px;
  }
`;
